import Axios from "axios";
import React, { useState } from "react";
import { api_url, PLATFORM } from "../../../config";
import Bouton from "../../common/HorsConnexion/Bouton";
import EcranResultat from "../../common/HorsConnexion/EcranResultat";
import { MESSAGE_SERVEUR_INDISPONIBLE, messageErreur } from "../../common/HorsConnexion/horsConnexion";
import Icone from "../../common/HorsConnexion/Icone";
import PiedCarte from "../../common/HorsConnexion/PiedCarte";
import Saisie from "../../common/HorsConnexion/Saisie";

/**
 * Vues « mot de passe oublié » puis « e-mail envoyé » de la page de connexion.
 * L'API répond toujours vrai (adresse connue ou non) : le message final reste
 * conditionnel, comme avant.
 */
const ForgotPassword = ({ emailInitial = "", retour }) => {
  const [email, setEmail] = useState(emailInitial);
  const [erreur, setErreur] = useState(null);
  const [envoi, setEnvoi] = useState(false);
  const [envoye, setEnvoye] = useState(false);

  function envoyer(e) {
    e.preventDefault();
    const adresse = email.trim();
    if (!adresse) {
      setErreur("Indiquez votre adresse e-mail.");
      return;
    }
    setEnvoi(true);
    setErreur(null);
    Axios.post(`${api_url}auth/renew-password/${PLATFORM}`, { login: adresse })
      .then(() => {
        setEnvoye(true);
      })
      .catch((err) => {
        const donnees = err.response && err.response.data;
        setErreur(
          (donnees && (donnees.login || donnees.email)) ||
            messageErreur(donnees) ||
            MESSAGE_SERVEUR_INDISPONIBLE
        );
      })
      .then(() => setEnvoi(false));
  }

  if (envoye) {
    return (
      <EcranResultat ton="succes" icone="enveloppe" titre="Consultez votre boîte e-mail">
        <p>
          Si l'adresse <strong>{email.trim()}</strong> est enregistrée dans ESPOAR, un message
          contenant le lien de réinitialisation vient de lui être envoyé.
        </p>
        <p>Pensez à vérifier vos courriers indésirables.</p>
        <Bouton secondaire onClick={retour}>
          Retour à la connexion
        </Bouton>
      </EcranResultat>
    );
  }

  return (
    <section aria-labelledby="titre-oubli">
      <button type="button" className="lien retour" onClick={retour}>
        <Icone nom="chevronGauche" epaisseur={2.2} />
        Retour à la connexion
      </button>
      <h2 id="titre-oubli">Mot de passe oublié</h2>
      <p className="sous-titre">
        Indiquez votre adresse e-mail. Si un compte lui est associé, vous recevrez un lien valable
        24 heures pour choisir un nouveau mot de passe.
      </p>

      <form onSubmit={envoyer} noValidate>
        <Saisie
          id="email-oubli"
          label="Adresse e-mail"
          type="email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setErreur(null);
          }}
          erreur={erreur}
          autoComplete="username"
          inputMode="email"
          placeholder="prenom.nom@exemple.fr"
          autoFocus
        />
        <Bouton type="submit" charge={envoi}>
          {envoi ? "Envoi en cours…" : "Recevoir le lien de réinitialisation"}
        </Bouton>
      </form>

      <PiedCarte>Le lien ne peut servir qu'une seule fois.</PiedCarte>
    </section>
  );
};

export default ForgotPassword;
